// Libs
import moment from 'moment';
import { memo, useCallback, useEffect, useState } from 'react';
import { Calendar, CalendarProps, DateLocalizer, momentLocalizer, Views } from 'react-big-calendar';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './BaseCalendar.scss';

export type BaseCalendarProps = Omit<CalendarProps, 'localizer'> & {
  localizer?: DateLocalizer;
};

moment.updateLocale('en', {
  week: { dow: 1 },
});

const localizer = momentLocalizer(moment);

const BaseCalendar = (props: BaseCalendarProps) => {
  //#region Destructuring Props
  const {
    views = {
      month: true,
      week: true,
      day: true,
    },
    formats = {
      dateFormat: 'D',
      weekdayFormat: 'dddd',
      dayFormat: 'dddd',
      timeGutterFormat: 'h A',
    },
    ...restProps
  } = props;
  //#endregion Destructuring Props

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [view, setView] = useState(restProps.view || Views.MONTH);
  const [date, setDate] = useState(restProps.date || moment().toDate());
  //#endregion Declare State

  //#region Declare Hook
  const onView = useCallback((newView: any) => setView(newView), [setView]);
  const onNavigate = useCallback((newDate: any) => setDate(newDate), [setDate]);
  //#endregion Declare Hook

  // #region Implement Hook
  useEffect(() => {
    if (props.view) setView(props.view);
  }, [props.view]);

  useEffect(() => {
    if (props.date) setDate(props.date);
  }, [props.date]);
  // #endregion Implement Hook

  return (
    <Calendar
      localizer={localizer}
      startAccessor='start'
      endAccessor='end'
      style={{ height: '100%' }}
      views={views}
      view={view}
      onView={onView}
      date={date}
      onNavigate={onNavigate}
      formats={formats}
      dayLayoutAlgorithm={view === 'day' ? 'no-overlap' : 'overlap'}
      {...restProps}
    />
  );
};

export default memo(BaseCalendar);
